/// <reference path="../../../../../../typings/globals/angular/index.d.ts" />

namespace ekh {


    class SelectedHotelController {
        public hotel: {[key: string]: any};
        public totalCost: number = 0;
        public basketId: string;
        public totalDeposit: number = 0;
        public depositAllowed: boolean = false;
        public showHotelImages: boolean = false;
        public hotelImages: {src: string}[];
        private imgWidth = TRPCONFIG.DeviceSettings.HotelImageMaxWidth;
        private imgHeight = TRPCONFIG.DeviceSettings.HotelImageMaxHeight;
        public hotelImageIndex: number = 0;
        public showCancellationsPopUp: boolean = false;


        constructor(
            private basketStore: any,
            private flightSearch: any,
            private $q: ng.IQService,
            private arrayUtil: any,
            private imageService: any
        ) {
        }

        $onInit() {
            this._initHotelImages();
            this.$q.all([
                this.basketStore.totalCost(this.basketId),
                this.basketStore.totalDeposit(this.basketId),
                this.basketStore.rules(this.basketId)
            ]).then(([totalCost, totalDeposit, rules]) => {
                this.totalCost = totalCost;
                this.totalDeposit = totalDeposit;
                this.depositAllowed = rules.depositAllowed;
            });
            this.findCancellationData();
        }

        private findCancellationData() {
            if (TRPCONFIG.Domain.BrandedFareCancellations) {
                this.showCancellationsPopUp = true;
            }
        };

        public showCancellationsDetails() {
            return this.flightSearch.showCancellationsDetailsModal();
        };

        private _initHotelImages() {
            const numberImages = this.hotel.Details.NumberOfPhotos - 1;
            const hotelId = this.hotel.Details.Id;
            this.hotelImages = this.arrayUtil.map(this.arrayUtil.numberArray(0, numberImages), i => {
                return {
                    src: this.imageService.getImageUrl(hotelId, this.imgWidth, this.imgHeight, i, false)
                };
            });
        }

        public openImageGallery() {
            this.showHotelImages = true;
        }
    }

    angular
        .module('ekh')
        .directive('selectedHotel', () => {
            return {
                restrict: 'E',
                templateUrl: 'partials/home/directivetemplate?type=selectedhotel',
                controller: SelectedHotelController,
                controllerAs: 'shCtrl',
                bindToController: {
                    hotel: '=',
                    basketId: '='
                }
            };
        });

}
